import { createSlotsContext } from "@grandvisionhq/slots";
const [PreferredStoreFormSlotsProvider, usePreferredStoreFormSlots] = createSlotsContext({
  displayName: "PreferredStoreFormSlotsContext"
});
export {
  PreferredStoreFormSlotsProvider,
  usePreferredStoreFormSlots
};
//# sourceMappingURL=PreferredStoreFormSlotsContext.js.map
